/**
 * Service worker registration.
 *
 * The worker itself is plain JavaScript in `public/sw.js`, deliberately not
 * bundled: it caches by URL pattern rather than from a build manifest, so a new
 * deployment cannot leave a tablet holding a manifest of files that no longer
 * exist.
 */

export function registerServiceWorker(): void {
  if (!("serviceWorker" in navigator)) return;
  if (import.meta.env.DEV) return; // a stale shell during development wastes an evening

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {
      // No worker means no offline shell. Everything else still works, and
      // saying so on screen would mean nothing to a twelve-year-old.
    });
  });
}
